import type { Client, RequestContext } from "../client";
import { ConfigurationRepository } from "../repositories/configurationRepository";
import type { AuditStreamConfigurationResource } from "../resources/auditStreamConfigurationResource";
import type { AuditStreamLicenseCheckResource } from "../resources/auditStreamLicenseCheckResource";
export class AuditStreamConfigurationRepository extends ConfigurationRepository<AuditStreamConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("AuditStreamConfiguration", client, requestContext);
    }
    getAuditStreamLicenseCheck(): Promise<AuditStreamLicenseCheckResource> {
        return this.client.get(this.requestContext, "~/bff/audit-stream/license-check");
    }
    async requestTrial() {
        return await this.client.post(this.requestContext, "~/bff/audit-stream/request-audit-stream-trial");
    }
}
